<script setup>
import { Icon } from '@iconify/vue';
import { useColorMode } from '@vueuse/core';
import { Switch } from '@/components/ui/switch';
import { computed } from 'vue';

const props = defineProps({
    variant: {
        type: String,
        default: 'switch', // 'switch' or 'button'
        validator: (value) => ['switch', 'button'].includes(value)
    }
});

const mode = useColorMode();

// For switch: true = dark, false = light (ignore auto)
const isDarkMode = computed({
    get: () => mode.value === 'dark',
    set: (value) => {
        mode.value = value ? 'dark' : 'light';
    }
});
</script>

<template>
    <div class="flex items-center gap-3" @click.stop>
        <Icon icon="radix-icons:sun" class="h-4 w-4" />
        Light
        <Switch v-model="isDarkMode" class="data-[state=checked]:bg-primary" />
        Dark
        <Icon icon="radix-icons:moon" class="h-4 w-4" />
    </div>
</template>
